export default function WhoItServes() {
  const audiences = [
    {
      title: 'الطلاب',
      description: 'مساحة للتعلم والعمل والتطوير المهني',
      image: '/youth-student.png',
      fallback: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=300&fit=crop&q=80',
      icon: 'ri-graduation-cap-line',
      color: 'from-[#FF6B6B] to-[#FF8E53]'
    },
    {
      title: 'المواهب الشابة',
      description: 'بيئة لتطوير المهارات وبناء الخبرات',
      image: '/youth-talent.png',
      fallback: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=400&h=300&fit=crop&q=80',
      icon: 'ri-star-line',
      color: 'from-[#FF8E53] to-[#FFA07A]'
    },
    {
      title: 'رواد الأعمال',
      description: 'دعم لتحويل الأفكار إلى مشاريع ناجحة',
      image: '/youth-entrepreneurs.png',
      fallback: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=300&fit=crop&q=80',
      icon: 'ri-rocket-line',
      color: 'from-[#FFA07A] to-[#FFB88C]'
    },
    {
      title: 'فرق الجهات الناشئة',
      description: 'مكاتب خاصة وموارد لتسريع النمو',
      image: '/youth-startups.png',
      fallback: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop&q=80',
      icon: 'ri-building-line',
      color: 'from-[#FFB88C] to-[#FF6B6B]'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#FFF5F3]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            من نخدم
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            نوفر بيئة داعمة لمجموعة متنوعة من المبتكرين والمبدعين
          </p>
        </div>

        {/* Audience Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
                <img
                  src={audience.image}
                  alt={audience.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = audience.fallback;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${audience.icon} text-[#FF6B6B] text-2xl`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl text-gray-900 mb-3">
                  {audience.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {audience.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
